import React from 'react'
import HeroSection from '../../components/HeroSection'
import OurClients from '../../components/OurClients'
import AboutSection from '../../components/About'
import StatSection from '../../components/StatSection'
import WhyChooseUs from '../../components/WhyChooseUs'
import Testimonials from '../../components/Testimonials'
import Services from '../../components/Services'
import Contact from '../../components/Contact';
import ProjectEnPruductPage from '../../components/projectenpruduct'

function Home() {
  return (
    <div className="space-y-16"> {/* ou space-y-20 pour plus d’espace */}
      <HeroSection />
      <ProjectEnPruductPage/>
      <OurClients />
      <Services />
      <AboutSection />
      <StatSection />
      <WhyChooseUs />
      <Testimonials />
      < Contact />
    </div>
  )
}


export default Home
